@if (error) {
<div class="row justify-content-center">
  <div class="col-md-8 text-center">
    <div class="alert alert-warning" role="alert">
      Er ging iets mis. Klik <a routerLink="/">hier</a> om opnieuw in te loggen.
    </div>
  </div>
</div>
}
@if (loading) {
<div class="loading">
  <mat-progress-spinner class="loading-spinner" [diameter]="250" mode="indeterminate" color="primary">
  </mat-progress-spinner>
  <div class="loading-text">
    <h1>Inloggen...</h1>
  </div>
</div>
}